import React from 'react'
import { Link } from 'react-router-dom'
import { HomePath } from '../home-path'

export default function BigAd({dark, route, minorHeading, majorHeading, text, buttonText}) {
  return (
    <div className={dark ? "h-fit py-16 md:py-24 bg-black shadow-xl shadow-gray-400/50" : "h-fit py-16 md:py-20 bg-gradient-to-tr from-red-700 to-orange-400 shadow-xl shadow-gray-400/50"}>
        <div className="w-full max-w-[1440px] mx-auto px-5 text-center">
            <div className="max-w-2xl mx-auto space-y-3 text-white">
                <p className="font-medium text-sm md:text-md">{minorHeading ? minorHeading : 'this is a missing minor heading'}</p>
                <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-black uppercase brightness-110">{majorHeading ? majorHeading : 'this is a missing majorHeading'}</h2>
                <p className="text-md md:text-lg lg:text-xl">{text ? text : 'missing text'}</p>
                <Link to={route ? route : HomePath + '/shop'}>
                  <span className="inline-block mt-2 md:mt-4 py-2 px-6 bg-white text-black font-medium rounded-3xl">{buttonText ? buttonText : 'missing buttonText'}</span>
                </Link>
            </div>
        </div>
    </div>
  )
}
